import { render } from "./Billing.vue?vue&type=template&id=45f83445&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "@/assets/Billing.css?vue&type=style&index=0&id=45f83445&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f83445"]])

export default __exports__